import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '../../../assets/css/customer/contact/ContactForm.css';

const ContactForm = () => {

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form Data:', formData);
    alert('Message sent successfully!');
    // Reset form
    setFormData({
      name: '',
      email: '',
      phone: '',
      service: '',
      message: ''
    });
  };

  return (
    <section className="contact-form-section">
      <Container>
        <Row className="align-items-center">
          {/* Left Side - Form with Image */}
          <Col lg={6} md={12} className="contact-form-col-left">
            <div className="contact-form-wrapper">
              {/* Decorative Image at Top */}
              <div className="contact-form-image">
                <img 
                  src="https://images.unsplash.com/photo-1522673607200-164d1b6ce486?w=600&h=200&fit=crop" 
                  alt="Wedding Flowers Decoration"
                  className="contact-decoration-img"
                />
              </div>

              {/* Contact Form */}
              <form className="contact-main-form" onSubmit={handleSubmit}>
                <Row className="contact-form-row">
                  {/* Name Field */}
                  <Col md={6} sm={12} className="contact-form-col">
                    <input
                      type="text"
                      name="name"
                      placeholder="Name"
                      className="contact-form-input"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </Col>

                  {/* Email Field */}
                  <Col md={6} sm={12} className="contact-form-col">
                    <input
                      type="email"
                      name="email"
                      placeholder="E-mail"
                      className="contact-form-input"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </Col>
                </Row>

                <Row className="contact-form-row">
                  {/* Phone Field */}
                  <Col md={6} sm={12} className="contact-form-col">
                    <input
                      type="tel"
                      name="phone"
                      placeholder="Phone"
                      className="contact-form-input"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                    />
                  </Col>

                  {/* Service Dropdown */}
                  <Col md={6} sm={12} className="contact-form-col">
                    <select
                      name="service"
                      className="contact-form-select"
                      value={formData.service}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Choose Services</option>
                      <option value="wedding-planning">Wedding Planning</option>
                      <option value="event-decoration">Event Decoration</option>
                      <option value="catering">Catering Services</option>
                      <option value="photography">Photography</option>
                      <option value="venue">Venue Booking</option>
                      <option value="other">Other Services</option>
                    </select>
                  </Col>
                </Row>

                {/* Message Textarea */}
                <div className="contact-form-group-full">
                  <textarea
                    name="message"
                    placeholder="Message"
                    className="contact-form-textarea"
                    rows="5"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                {/* Submit Button */}
                <button type="submit" className="contact-form-submit-btn">
                  Order Services
                </button>
              </form>
            </div>
          </Col>

          {/* Right Side - Content */}
          <Col lg={6} md={12} className="contact-content-col-right">
            <div className="contact-content-wrapper">
              {/* Decorative Icon */}
              <div className="contact-decorative-icon">
                <svg width="50" height="50" viewBox="0 0 50 50" fill="none">
                  <circle cx="25" cy="25" r="3" fill="#ffb8b8"/>
                  <path d="M25 15 L28 20 L33 20 L29 24 L31 29 L25 25 L19 29 L21 24 L17 20 L22 20 Z" 
                        fill="#e8b4b8" opacity="0.6"/>
                  <circle cx="15" cy="15" r="2" fill="#ffa5a5" opacity="0.5"/>
                  <circle cx="35" cy="15" r="1.5" fill="#ffb8b8" opacity="0.4"/>
                  <path d="M20 35 Q25 40 30 35" stroke="#e8b4b8" strokeWidth="2" fill="none" opacity="0.5"/>
                </svg>
              </div>

              {/* Main Heading */}
              <h2 className="contact-content-heading">
                Interested in<br />
                discussing? Get In<br />
                touch with us.
              </h2>

              {/* Description */}
              <p className="contact-content-description">
                Lorem ipsum dolor sit amet consect etur adipisci ngsellisda do eiu smo d tempor incididunt ut labo re eldo lore magna aliqua qusfpolor.
              </p>

              {/* Follow Us Label */}
              <p className="contact-follow-label">Follow us:</p>

              {/* Social Media Icons */}
              <div className="contact-social-icons">
                <a href="#" className="contact-social-link" aria-label="Facebook">
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <circle cx="20" cy="20" r="20" fill="#7fd3c1"/>
                    <path d="M22 14V17H20C19.4 17 19 17.4 19 18V20H22L21.5 23H19V30H16V23H14V20H16V17.5C16 15.6 17.6 14 19.5 14H22Z" 
                          fill="white"/>
                  </svg>
                </a>

                <a href="#" className="contact-social-link" aria-label="Twitter">
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <circle cx="20" cy="20" r="20" fill="#7fd3c1"/>
                    <path d="M28 15C27.4 15.3 26.8 15.4 26.1 15.5C26.8 15.1 27.3 14.5 27.5 13.7C26.9 14.1 26.2 14.3 25.4 14.5C24.8 13.9 23.9 13.5 23 13.5C21.3 13.5 19.8 15 19.8 16.8C19.8 17.1 19.8 17.3 19.9 17.5C17.2 17.4 14.8 16.1 13.2 14.1C12.9 14.6 12.7 15.1 12.7 15.7C12.7 16.7 13.2 17.6 14 18.1C13.5 18.1 13 17.9 12.6 17.7V17.7C12.6 19.3 13.7 20.6 15.2 20.9C15 21 14.7 21 14.4 21C14.2 21 14 21 13.8 20.9C14.2 22.2 15.4 23.2 16.9 23.2C15.8 24.1 14.4 24.6 12.8 24.6C12.5 24.6 12.3 24.6 12 24.6C13.5 25.5 15.2 26 17 26C23 26 26.3 21.1 26.3 17.2V16.7C27 16.2 27.6 15.6 28 15Z" 
                          fill="white"/>
                  </svg>
                </a>

                <a href="#" className="contact-social-link" aria-label="YouTube">
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <circle cx="20" cy="20" r="20" fill="#7fd3c1"/>
                    <path d="M28.5 16.5C28.5 15.1 27.4 14 26 14H14C12.6 14 11.5 15.1 11.5 16.5V23.5C11.5 24.9 12.6 26 14 26H26C27.4 26 28.5 24.9 28.5 23.5V16.5ZM18 22V18L23 20L18 22Z" 
                          fill="white"/>
                  </svg>
                </a>

                <a href="#" className="contact-social-link" aria-label="Instagram">
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <circle cx="20" cy="20" r="20" fill="#7fd3c1"/>
                    <path d="M20 14C17.2 14 15 16.2 15 19C15 21.8 17.2 24 20 24C22.8 24 25 21.8 25 19C25 16.2 22.8 14 20 14ZM20 22C18.3 22 17 20.7 17 19C17 17.3 18.3 16 20 16C21.7 16 23 17.3 23 19C23 20.7 21.7 22 20 22ZM26 14C26 14.6 25.6 15 25 15C24.4 15 24 14.6 24 14C24 13.4 24.4 13 25 13C25.6 13 26 13.4 26 14ZM28 15C28 13.3 26.7 12 25 12H15C13.3 12 12 13.3 12 15V25C12 26.7 13.3 28 15 28H25C26.7 28 28 26.7 28 25V15ZM26 25C26 25.6 25.6 26 25 26H15C14.4 26 14 25.6 14 25V15C14 14.4 14.4 14 15 14H25C25.6 14 26 14.4 26 15V25Z" 
                          fill="white"/>
                  </svg>
                </a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ContactForm;